export default "__VITE_ASSET__Dq16f4lh__"